/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable no-confusing-arrow */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable quotes */
/* eslint-disable indent */
/* eslint-disable react/jsx-curly-newline */
export const INTERNET_COAXAL = {
  AVAILABLE: "Coax: Disponible",
  LEADED: "Coax: Plombé",
  ACTIVE_PARTNER: "Coax: Partenaire",
  ACTIVE_TVT: "Coax: TVT Basic",
  ACTIVE_TVT_TV_PLUS: "Coax: TV+",
  UNAVAILABLE: "Coax: Indisponible"
};

export const INTERNET_OPTIQ = {
  ACTIVE_PARTNER: "Fibre: Partenaire",
  AVAILABLE: "Fibre: Disponible",
  TVT_PRO: "Fibre: TVT Pro",
  UNAVAILABLE: "Fibre: Indisponible"
};

export const INTERNET_STATUS = {
  MULTIPLE: "Multiples abonnements",
  UNAVAILABLE: "Indisponible",
};
